import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function usePhoneLayout() {
  const theme = useTheme();
  const narrow = useMediaQuery(theme.breakpoints.down('sm'));
  const shortCoarse = useMediaQuery(
    '(pointer: coarse) and (max-height: 599.95px)',
  );
  return narrow || shortCoarse;
}
